<template>
  <div class="home">
    <el-container style="height: 100vh">
      <el-aside width="200px">
        <Aside></Aside>
      </el-aside>
      <el-main style="padding-top: 0; padding-bottom: 0">
        <Main></Main>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Aside from '@/views/Aside'
import Main from "@/views/Main";
import {postRecord, userInfo} from "@/api/user/login";
import {setUserInfo} from "@/utils/utils";

export default {
  name: 'HomeView',
  components: {
    Aside,
    Main
  },
  created() {
    // 上传记录
    this.uploadRecord()
    this.getUserInfo()
  },
  methods: {
    handleScroll() {
      console.log('dasdadad')
    },

    // 上传记录
    uploadRecord(){
      let postData = {
        product_code: 'fugenerator'
      }
      postRecord(postData)
    },
    getUserInfo() {
      userInfo().then(res=>{
        const {data, msg, error_code} = res.data
        setUserInfo(data)
      })
    }
  }
}
</script>

<style lang="scss">
.el-main {
  background-color: var(--current-bg-color);
}
.el-aside {
  background-color: var(--current-aside-color);
}
</style>
